import React from "react";
import { FormCard } from "@/components/FormCard";
import { Button } from "@/components/ui";

interface Props {
  hasChanges: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const SaveCancelActions: React.FC<Props> = ({ hasChanges, isSaving, onCancel, onSave }) => (
  <FormCard.Actions className="max-lg:sticky max-lg:bottom-0 max-lg:z-10 max-lg:bg-slate-50">
    {hasChanges && (
      <span className="mr-auto flex items-center gap-2 self-center text-sm text-slate-600" role="status">
        <span className="size-2 rounded-full bg-amber-500" aria-hidden />
        Unsaved changes
      </span>
    )}
    <Button type="button" variant="outline" className="w-20" disabled={!hasChanges || isSaving} onClick={onCancel}>
      Cancel
    </Button>
    <Button type="button" loading={isSaving} className="w-20" disabled={!hasChanges} onClick={onSave}>
      Save
    </Button>
  </FormCard.Actions>
);

export { SaveCancelActions };
